export const Tag = ({ children }) => {
  return (
    <div className="inline-block h-[22px] leading-[20px] text-[14px] px-[8px] mr-[4px] text-black bg-white rounded-[6px] border border-solid border-black">
      {children}
    </div>
  );
};

export const Tag2 = ({ children }) => {
  return (
    <div className="inline-block h-[22px] leading-[20px] text-[12px] px-[8px] mr-[4px] mt-[2px] mb-[10px] text-white rounded-[6px] border border-solid border-white">
      {children}
    </div>
  );
};
